angular.module('app').run(function () {
  _.templateSettings = {
    interpolate: /{{([\s\S]+?)}}/g
  };
});
